import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { Router } from '@angular/router';
import { CategoriaServiceService } from 'src/app/servicios/categoria-service.service';

@Component({
  selector: 'app-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.scss']
})
export class CategoriasComponent implements OnInit {

  constructor(
		public globals: Globals,
		private productoService: ProductoService,
		private router: Router,
    private categoriaService: CategoriaServiceService
  ) { 
  
    localStorage.setItem('lastRoute','');
    localStorage.setItem('busqueda','');
  }

  seleccionarCetegoria( categoria ){
    this.globals.configuracion.front.listado.categoria = categoria.categoryid;
    this.globals.configuracion.front.listado.categoria_nombre = categoria.categorydescription;
    this.categoriaService.cambiarCategoria(categoria);
    this.globals.setDataFront();

    this.router.navigate(['/precio-tipo']);
  }

  categorias = {
    cargando: true,
    registros: new Array()
  }

  categoriasListado(){
    this.categorias.cargando = true;

    this.productoService.categoriaListado().subscribe(
        resultado =>{
          if( !resultado.error ){
            Array.prototype.push.apply( this.categorias.registros, resultado.registros );
            this.categorias.cargando = false;
          }else{
            console.log("Error",resultado.mensaje);
          }

        },
        error =>{
          console.log("Error",error);
          //this.feedProductos.cargando = false;
        }
      )
  }

  ngOnInit(): void {
    localStorage.setItem("paginaActual",'1');
    localStorage.setItem("busqueda",'');
    this.globals.configuracion.front.listado.busqueda = '';
    this.globals.configuracion.front.listado.ordenar_new = 'relevancia_producto';
    this.globals.configuracion.front.listado.ordenar_modo = 'desc';
    this.globals.configuracion.front.listado.categoria = '';
    this.globals.configuracion.front.listado.categoria_nombre = '';
    this.globals.configuracion.front.listado.marca = '';
    this.globals.configuracion.front.listado.modelo = '';
    this.globals.configuracion.front.listado.modelos = new Array();
    this.globals.configuracion.front.listado.tags = new Array();
    this.globals.configuracion.front.listado.tag = "";
    this.globals.configuracion.front.listado.tag_descripcion = "";
    this.globals.setDataFront();

    this.categoriasListado();
  }

}
